module.exports = __webpack_public_path__ + "img/certificates.3f6a42cf.svg";